export const howItWorks = {
  hero: {
    badge: "Pełny przewodnik",
    title: "Jak działa DONKEY TRAVEL?",
    subtitle:
      "Odkryj krok po kroku, jak wymienić swój dom Airbnb z innymi właścicielami i podróżować za darmo po Europie.",
    cta: "Zacznij teraz",
    learnMore: "Zobacz kroki",
  },
  stats: {
    properties: "Dostępne domy",
    exchanges: "Zrealizowane wymiany",
    countries: "Obsługiwane kraje",
    satisfaction: "Satysfakcja",
  },
  steps: {
    badge: "Proces",
    title: "Twoja wymiana w 7 krokach",
    subtitle:
      "Prosta i bezpieczna ścieżka, od rejestracji do Twojej pierwszej darmowej podróży",
    step1: {
      title: "Utwórz swój profil (15 min)",
      description:
        'To "najdłuższy" etap: 15 minut na utworzenie profilu. Mały wysiłek dla lat darmowych wakacji i szczęścia!',
      highlight1: "Wymagana subskrypcja",
      highlight2: "Kompletne ogłoszenie ze zdjęciami",
      highlight3: "Weryfikacja tożsamości",
      badge: "Szybka rejestracja",
    },
    step2: {
      title: "Odkrywaj i znajdź idealne miejsce docelowe",
      description:
        "Przeglądaj naszą interaktywną mapę Europy i znajdź zweryfikowanych gospodarzy klubu. Filtruj według miejsca docelowego, dat, typu domu i udogodnień, aby zorganizować wymianę.",
      highlight1: "Interaktywna mapa Europy z zaawansowanymi filtrami",
      highlight2: "Wyszukiwanie według miejsca docelowego, dat i udogodnień",
      highlight3:
        "Zweryfikowani członkowie-gospodarze w dostępnych krajach europejskich",
      badge: "Inteligentne wyszukiwanie",
    },
    step3: {
      title: "Zaproponuj wymianę i negocjuj",
      description:
        "Skontaktuj się z właścicielem, który Cię interesuje, i zaproponuj wymianę. Negocjuj daty i czas trwania w przyjaznej atmosferze. 10 nocy za 5? Wszystko jest możliwe!",
      highlight1: "Zintegrowane i bezpieczne wiadomości",
      highlight2: "Elastyczna negocjacja długości pobytu",
      highlight3: "Zweryfikowane profile i dostępne opinie",
      badge: "Łatwa negocjacja",
    },
    step4: {
      title: "Potwierdź daty i zsynchronizuj kalendarze",
      description:
        "Po osiągnięciu porozumienia potwierdź daty wymiany. Twoje kalendarze Airbnb i DONKEY TRAVEL synchronizują się automatycznie, aby uniknąć konfliktów rezerwacji.",
      highlight1: "Automatyczna synchronizacja z Airbnb",
      highlight2: "Przypomnienia i powiadomienia przed pobytem",
      highlight3: "Elastyczna modyfikacja do 48h przed",
      badge: "Zsynchronizowany kalendarz",
    },
    step5: {
      title: "Umowa polubowna PDF wysyłana do obu gospodarzy",
      description:
        "DONKEY TRAVEL generuje umowę polubowną w PDF i wysyła ją do obu gospodarzy. Po zakończeniu pierwszej wymiany masz 24 miesiące na zrealizowanie wymiany zwrotnej.",
      highlight1: "Umowa polubowna PDF wysyłana automatycznie do 2 gospodarzy",
      highlight2: "Dokument podsumowujący zatwierdzone daty i warunki",
      highlight3:
        "24 miesiące na realizację wymiany zwrotnej po pierwszym pobycie",
      badge: "Umowa PDF",
    },
    step6: {
      title: "Podróżuj i ciesz się darmowym pobytem!",
      description:
        "To wielki dzień! Rozgość się w swoim domu wymiany i ciesz się autentycznymi wakacjami. Po pobycie zostaw opinię, aby pomóc społeczności.",
      highlight1: "Spersonalizowane powitanie przez właściciela",
      highlight2: "Lokalny przewodnik z rekomendacjami",
      highlight3: "System opinii po każdej wymianie",
      badge: "Dobrej podróży!",
    },
  },
  advantages: {
    badge: "Nasze zalety",
    title: "Dlaczego warto wybrać DONKEY TRAVEL?",
    subtitle:
      "Platforma zaprojektowana dla właścicieli Airbnb, którzy chcą podróżować inaczej",
    items: {
      security: {
        title: "Maksymalne bezpieczeństwo",
        description:
          "Wszyscy członkowie są zweryfikowanymi właścicielami Airbnb. Sprawdzona tożsamość, dostępne opinie i ubezpieczenie wliczone w każdą wymianę.",
      },
      savings: {
        title: "Znaczne oszczędności",
        description:
          "Podróżuj za darmo, wymieniając swoje noce. Oszczędzaj średnio 2 500€ rocznie na kosztach zakwaterowania.",
      },
      community: {
        title: "Zaufana społeczność",
        description:
          "Dołącz do naszej społeczności podróżników. Dziel się doświadczeniami, wymieniaj porady i twórz trwałe więzi.",
      },
      support: {
        title: "Wsparcie 7/7",
        description:
          "Nasz zespół jest dostępny w każdej chwili, aby Ci pomóc. Czat na żywo, email i telefon dla pełnego wsparcia.",
      },
      quality: {
        title: "Domy wysokiej jakości",
        description:
          "Każdy dom jest weryfikowany i oceniany przez społeczność. Wysokie standardy, aby zagwarantować wyjątkowe pobyty.",
      },
      global: {
        title: "Europejska sieć",
        description:
          "Uzyskaj dostęp do zweryfikowanych gospodarzy w dostępnych krajach europejskich klubu i organizuj wymiany z zaufaniem.",
      },
    },
  },
  testimonials: {
    badge: "Opinie",
    title: "Sprawdzili i zatwierdzili",
    subtitle: "Odkryj doświadczenia naszych członków z całego świata",
    banner: {
      title: "Ty też możesz podróżować częściej!",
      subtitle:
        "Dołącz do społeczności gospodarzy, którzy podróżują w nowym stylu.",
    },
    items: {
      sophie: {
        name: "Sophie",
        location: "Paryż, Francja",
        badge: "2 wymiany",
        text: "Dzięki DONKEY TRAVEL odwiedziłam Barcelonę, Rzym i Amsterdam bez płacenia za nocleg. Społeczność szybko odpowiada, a rozmowy o wymianie są proste.",
      },
      marc: {
        name: "Marc",
        location: "Marsylia, Francja",
        badge: "1 wymiana",
        text: "Proces jest niesamowicie prosty. W 3 dni znalazłem idealną wymianę na letnie wakacje. Synchronizacja z Airbnb to ogromny plus.",
      },
      leaTom: {
        name: "Léa i Tom",
        location: "Lyon, Francja",
        badge: "Nowi członkowie",
        text: "To, co wywarło na nas największe wrażenie, to społeczność. Właściciele są wyrozumiali, a wymiany przebiegają w atmosferze pełnego zaufania.",
      },
      dupont: {
        name: "Rodzina Dupont",
        location: "Bordeaux, Francja",
        badge: "3 wymiany",
        text: "Idealne rozwiązanie na rodzinne wyjazdy podczas wakacji szkolnych!",
      },
      alex: {
        name: "Alex",
        location: "Berlin, Niemcy",
        badge: "5 wymian",
        text: "Niesamowita sieć do pracy zdalnej. Wymieniam swój berliński loft na słoneczne mieszkania na południu.",
      },
      marie: {
        name: "Marie",
        location: "Tuluza, Francja",
        badge: "4 wymiany",
        text: "Koniec z ograniczeniami finansowymi! Co miesiąc wyjeżdżam na weekend.",
      },
      testimonial2: {
        text: "Proces jest taki prosty. W 3 dni znalazłem idealną wymianę na moje letnie wakacje. Synchronizacja z Airbnb to prawdziwy plus.",
      },
      testimonial3: {
        text: "To, co mnie najbardziej urzekło, to społeczność. Właściciele są życzliwi, a wymiany odbywają się w atmosferze całkowitego zaufania.",
      },
    },
  },
  faq: {
    title: "Częste pytania",
    subtitle: "Wszystko, co musisz wiedzieć przed rozpoczęciem",
    items: {
      q1: {
        question: "Czy rejestracja jest płatna?",
        answer:
          "Tak. Dostęp do DONKEY TRAVEL odbywa się poprzez roczną subskrypcję. Oferta startowa 2026: 25EUR/rok zamiast 50EUR/rok.",
      },
      q2: {
        question: "Czy muszę być właścicielem Airbnb, aby się zarejestrować?",
        answer:
          "Tak, DONKEY TRAVEL jest zarezerwowany dla właścicieli posiadających dom wystawiony na Airbnb. To gwarantuje jakość i niezawodność każdego członka społeczności.",
      },
      q3: {
        question: "Jak chronione są wymiany?",
        answer:
          "Każda wymiana jest objęta naszym ubezpieczeniem partnerskim. Ponadto wszyscy członkowie są weryfikowani (tożsamość, dom, opinie Airbnb), a nasz zespół wsparcia jest dostępny 7 dni w tygodniu.",
      },
      q4: {
        question: "Czy mogę wymieniać się z kimś w innym kraju?",
        answer:
          "Tak. Możesz wymieniać się z innymi zweryfikowanymi gospodarzami w dostępnych krajach europejskich zgodnie z Twoją subskrypcją.",
      },
      q5: {
        question: "Co się dzieje, jeśli wymiana zostanie anulowana?",
        answer:
          "Nasza polityka anulowania chroni obie strony. W przypadku anulowania pomagamy znaleźć alternatywę.",
      },
      q6: {
        question: "Ile czasu trwa średnio wymiana?",
        answer:
          "Długość jest całkowicie elastyczna i negocjowana między dwoma właścicielami. Średnio wymiany trwają od 5 do 14 nocy, ale niektórzy wymieniają się na weekend lub cały miesiąc.",
      },
    },
  },
  cta: {
    title: "Gotowy na darmowe podróże?",
    subtitle: "Dołącz do naszej społeczności podróżników.",
    explore: "Przeglądaj miejsca docelowe",
    members: "Aktywni członkowie",
    countries: "Dostępne kraje",
    satisfaction: "Zadowolenia",
  },
};
